import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connectToStores } from 'fluxible-addons-react';
import { FormattedMessage } from 'react-intl';
import accountMessages from './AccountMessages';
import Actions from '../../../constants/Actions';
import GenerateResetForm from './GenerateResetForm';
import {locationShape} from 'react-router';

@connectToStores(['AuthenticationStore'], (context) => {
  const AuthenticationStore = context.getStore('AuthenticationStore');

  return {
    formSubmitted: AuthenticationStore.formSubmitted() || false,
    formLoading: AuthenticationStore.formLoading() || false
  };
})
class Forgot extends Component {

  static propTypes = {
    formSubmitted: PropTypes.bool.isRequired,
    formLoading: PropTypes.bool.isRequired,
    location: locationShape.isRequired
  };

  constructor(props) {
    super(props);
  }

  static async loadAction(context) {
    context.dispatch(Actions.AUTHENTICATION__FORM_STATE_CLEARED, {});
  }

  render() {
    const { formSubmitted, formLoading, location: {query: {emailAddress} = {}} } = this.props;

    const component = formSubmitted ?
      [] :
      <div className='card-body'>
        <GenerateResetForm passwordResetLoading={ formLoading } defaultEmailAddress={emailAddress}/>
      </div>;

    const promptMessage = formSubmitted ? accountMessages.forgotComplete : accountMessages.forgotPrompt;

    return <div className='login-container'>
      <div className='card'>
        <div className='card-body'>
          <h2 className='card-title'>
            <FormattedMessage { ...accountMessages.forgotHeader } />
          </h2>
          <h4 className='card-subtitle text-muted'>
            <FormattedMessage { ...promptMessage } />
          </h4>
        </div>
        { component }
      </div>
    </div>;
  }
}

export default Forgot;



// WEBPACK FOOTER //
// ./src/apps/Account/components/Forgot.js